/* src/components/UpdateModal.js */
import React from 'react';
import { FaRocket, FaCloudDownloadAlt, FaExternalLinkAlt } from 'react-icons/fa';
import './UpdateModal.css';

const UpdateModal = ({ isOpen, playStoreUrl, message, latestVersion }) => {
  if (!isOpen) return null;

  const handleUpdateClick = () => {
    if (playStoreUrl) {
      window.open(playStoreUrl, '_blank');
    }
  };

  return (
    <div className="up-modal-backdrop">
      <div className="up-modal">
        <header className="up-header">
          <div className="up-badge">v{latestVersion}</div>
          <div className="up-icon-wrapper">
            <FaRocket />
          </div>
          <h2>¡Nueva mejora disponible!</h2>
        </header>

        <div className="up-body">
          <p>{message}</p>
          
          <button 
            className="up-action-btn" 
            onClick={handleUpdateClick}
          >
            <FaCloudDownloadAlt /> Actualizar Ahora
          </button>

          <div className="up-footer-note">
            Es necesario actualizar para garantizar la seguridad y estabilidad del servicio.
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateModal;
